import type { BariPostSecretarialAssistantFollowUpData } from '@common/validation/customControls/bariPost/bariPostSecretarialAssistentFollowUp/v1/bariPostSecretarialAssistentFollowUpSchemaV1';

export const initialData: BariPostSecretarialAssistantFollowUpData = {
    aanwezigheid: null,
    assets: [],
    bijzonderheden_labuitslag: null,
    buikomvang: null,
    gewicht_in_kg: null,
    lengte_in_cm: null,
    moment: null,
    toelichting_no_show: null,
};
